export enum AppErrorType {
  ProfileUnregistered,
  AgreementStatusesNothing,
  CurrentUserNotFound,
}

export class AppError extends Error {
  constructor(type: AppErrorType) {
    super('');

    switch (type) {
      case AppErrorType.ProfileUnregistered:
        this.name = 'AppError::ProfileUnregistered';
        this.message = 'Profile is not registered';
        break;
      case AppErrorType.AgreementStatusesNothing:
        this.name = 'AppError::AgreementStatusesNothing';
        this.message = 'AgreementStatuses is nothing';
        break;
      case AppErrorType.CurrentUserNotFound:
        this.name = 'AppError::CurrentUserNotFound';
        this.message = 'Current user not found';
        break;
      default:
        this.name = 'AppError::UnknownError';
        this.message = 'エラーが発生しました。';
    }
  }
}

class APIClientError extends Error {
  name = '';
  message = '';

  constructor() {
    super('');
  }
}
